import { Input as AntInput } from "antd";
import type { InputProps as AntInputProps, PasswordProps, TextAreaProps } from "antd/es/input";

interface CustomInputProps extends AntInputProps {
  label?: string;
  error?: string;
  labelClassName?: string;
}

export function Input({ label, error, labelClassName, ...props }: CustomInputProps) {
  return (
    <div className="flex flex-col gap-1">
      {label && (
        <label className={`text-sm font-medium ${labelClassName || "text-gray-700"}`}>
          {label}
        </label>
      )}
      <AntInput status={error ? "error" : undefined} {...props} />
      {error && <span className="text-xs text-red-500">{error}</span>}
    </div>
  );
}

// Password Input
interface CustomPasswordInputProps extends PasswordProps {
  label?: string;
  error?: string;
  labelClassName?: string;
}

export function PasswordInput({
  label,
  error,
  labelClassName,
  ...props
}: CustomPasswordInputProps) {
  return (
    <div className="flex flex-col gap-1">
      {label && (
        <label className={`text-sm font-medium ${labelClassName || "text-gray-700"}`}>
          {label}
        </label>
      )}
      <AntInput.Password status={error ? "error" : undefined} {...props} />
      {error && <span className="text-xs text-red-500">{error}</span>}
    </div>
  );
}

// TextArea Input
interface CustomTextAreaProps extends TextAreaProps {
  label?: string;
  error?: string;
  labelClassName?: string;
}

export function TextArea({
  label,
  error,
  labelClassName,
  ...props
}: CustomTextAreaProps) {
  return (
    <div className="flex flex-col gap-1">
      {label && (
        <label className={`text-sm font-medium ${labelClassName || "text-gray-700"}`}>
          {label}
        </label>
      )}
      <AntInput.TextArea status={error ? "error" : undefined} {...props} />
      {error && <span className="text-xs text-red-500">{error}</span>}
    </div>
  );
}
